import { ReportConfiguration } from "../../configuration"
import { getPlaceholderChartBodyOptions } from "../pptx-configuration/placeholders"
import { DocumentSection } from "../types"
import * as ReactDOM from "react-dom"
import * as React from "react"
import { getHtmlToPowerPointBaseOptions } from "../pptx-configuration/slides"
import PptxGenJS, { Slide } from "pptxgenjs"
import * as CommonUtils from "../utils"
import DobTable from "./dob-table/dob-table"
import * as Color from "color"
import * as CashFlowDomain from "../../../../domain/sfp/cash-flow-domain"
import * as LoanDomain from "../../../../domain/sfp/loan-domain"
import * as DobDomain from "../../../../domain/sfp/dob-domain"
import { LoanDecomposition, LocalAuthority, Ppi, Scenario } from "../../../../model"
import Operations from "../../../scenarii/common/operations"
import * as Tabledefinition from "./../../../scenarii/detail/table-definition"


export function checkDobTableSection(
    configuration: ReportConfiguration,
): boolean {
    return configuration.dob.table
}

export function createDobTableSection(
    configuration: ReportConfiguration,
    pptx: PptxGenJS,
    numbering: number[],
    years: number[],
    currentYear: number,
    scenario: Scenario,
    loanDecompositions: LoanDecomposition[],
    localAuthority: LocalAuthority,
    loans: any,
    ppi: Ppi
): DocumentSection {
    const referenceYear = configuration.generalities.referenceYear

    const placeholderBodyOptions = getPlaceholderChartBodyOptions()
    const baseColor = new Color(configuration.table.header.backgroundColor)
    const title = CommonUtils.formatTitle(
        "Débat d'orientation budgétaire", numbering)
    const slides: Slide[] = []

    //Récupération des données du tableau
    const targetCaf = [];
    const loanRefund = [];
    const cafNette = [];
    const loanCafRefund = [];
    const remainingCapitals = [];
    const grossCashFlows = []
    const recurentInvests = [];
    const autofinancingNet = [];

    const getOperations = (): Operations => {
        scenario.year = referenceYear;
        return new Operations(scenario, ppi, localAuthority)
    }

    years.forEach((y, i) => {
        // Objectif CAF
        targetCaf.push(localAuthority.minimumGrossCashFlow);
        // Capital restant dû
        remainingCapitals.push(LoanDomain.getTotalYearRemainingCapital(loanDecompositions, y))
        // Remboursement des emprunts
        loanRefund.push(LoanDomain.getYearReimbursedCapital(loans, y))

        if (scenario) {
            const cafNetteValue = localAuthority.minimumGrossCashFlow - LoanDomain.getYearReimbursedCapital(loans, y);
            let type: any = y < currentYear ? "retrospective" : "prospective"
            // CAF nette : Objectif CAF - remboursement d'emprunt
            cafNette.push(cafNetteValue);
            // CAF brute
            grossCashFlows.push(Tabledefinition._aggregateCAFBrute(type, y, localAuthority, getOperations(), null, [], loans))
            //Investissement recurent
            recurentInvests.push(DobDomain.getReccurentInvestsForOneYear(y, ppi))
            //Autofinancement net : Caf Nette - Investissement récurrent
            autofinancingNet.push(cafNetteValue - DobDomain.getReccurentInvestsForOneYear(y, ppi))
            //Remboursement Emprunt / Objectif CAF 
            loanCafRefund.push(DobDomain.computeTauxRemboursement(LoanDomain.getYearReimbursedCapital(loans, y), localAuthority.minimumGrossCashFlow))
        } else {
            grossCashFlows.push(0);
            cafNette.push(0);
            recurentInvests.push(0);
            autofinancingNet.push(0);
        }
    });

    const deleveragingYears = CashFlowDomain.calculateCashFlowDeleveragingYears(grossCashFlows, remainingCapitals)

    // tables
    if (configuration.dob.table) {
        const tempDiv = document.createElement("div")
        document.head.appendChild(tempDiv)

        const tableId = `dob-prospective-table`
        const table = <DobTable
            targetCaf={targetCaf}
            loanRefund={loanRefund}
            cafNette={cafNette}
            recurentInvests={recurentInvests}
            autofinancingNet={autofinancingNet}
            deleveragingYear={deleveragingYears}
            loanCafRefund={loanCafRefund}
            remainingCapital={remainingCapitals}
            currentYear={currentYear}
            currency={configuration.currency}
            id={tableId}
            locale={configuration.locale}
            roundness={configuration.generalities.roundness}
            enableHideZeroLines={configuration.generalities.enableHideZeroLines}
            tableConfiguration={configuration.table}
            years={years} />

        ReactDOM.render(table, tempDiv, () => {
            const options = getHtmlToPowerPointBaseOptions(title)
            pptx.addSlidesForTable(tableId, options)
            document.head.removeChild(tempDiv)
        })
    }

    return { slides, title }
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/dob-generator/dob-generator.tsx